import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页-佛山市纳木措国际货运代理有限公司",
            routerName: "首页"
          }
        },
        {
          path: "/product",
          name: "product",
          component: resolve => require(["@/view/product"], resolve),
          meta: {
            title: "国际物流-佛山市纳木措国际货运代理有限公司",
            routerName: "国际物流"
          }
        },
        {
          path: "/search",
          name: "search",
          component: resolve => require(["@/view/search"], resolve),
          meta: {
            title: "物流查询-佛山市纳木措国际货运代理有限公司",
            routerName: "物流查询"
          }
        },
        {
          path: "/aboutUs",
          name: "about_us",
          component: resolve => require(["@/view/AboutUs"], resolve),
          meta: {
            title: "关于我们-佛山市纳木措国际货运代理有限公司",
            routerName: "关于我们"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js